import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import styles from "./styles.less";
import ResultsGroup from "../ResultsGroup";
import { Header } from "../../components/common";

export class RegionsHotelsGroup extends Component {
  /// Normal region hotel object model to an acceptable thumbnail object
  normalizeRhrToProduct = regionHotel => {
    const product = {
      id: regionHotel.hotelID,
      name: regionHotel.name,
      lowestPrice: regionHotel.startFromPrice,
      currency: regionHotel.currency,
      currencyCode: regionHotel.currencyCode,
      description: regionHotel.hotelDescription,
      images: regionHotel.images,
      defaultImage: regionHotel.defaultImage
    };
    return product;
  };

  renderRegionHotels = (regionHotels, key) => {
    const {
      isRtl,
      titles,
      isMobileView,
      onRegionHotelClick,
      onShowHotelDetailsClick,
      selectedType,
      propertyType,
      checkinDate,
      checkoutDate,
      clubUserLoggedIn,
      showPricePerNightThumb,
      discountClubConfig
    } = this.props;
    return (
      <ResultsGroup
        key={key}
        isRtl={isRtl}
        isMobileView={isMobileView}
        isRegionResult={true}
        titles={titles}
        onResultClick={onRegionHotelClick}
        onShowDetailsClick={onShowHotelDetailsClick}
        results={regionHotels}
        normalizeResult={this.normalizeRhrToProduct}
        selectedType={selectedType}
        MoreDetailsTitle={titles.HotelMoreDetails}
        propertyType={propertyType}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        clubUserLoggedIn={clubUserLoggedIn}
        showPricePerNightThumb={showPricePerNightThumb}
        discountClubConfig={discountClubConfig}
      />
    );
  };

  getGroupTitle = () => {
    const {
      selectedType,
      regionResults,
      titles
      //propertyTypePlural
    } = this.props;
    let res = "";
    if (regionResults[0].regionId > 0) {
      if (selectedType == "City") {
        res = regionResults[0] && regionResults[0].cityTitle;
      } else {
        res = regionResults[0] && regionResults[0].title;
      }
    }
    if (res && res.length > 1) {
      return `${titles.Results} ${titles.MatchYourSearchResults}${res}`;
    }
  };

  render() {
    const { regionResults, isRtl, isMobileView } = this.props;
    const title = this.getGroupTitle();
    return (
      <div className={styles.mainRegionsHotelsWrapper}>
        {title && (
          <Grid.Row>
            <Grid.Column width={16}>
              <Header
                text={title}
                isRtl={isRtl}
                isMobileView={isMobileView}
                className={styles.customSubTitle}
                lightBottomPadding={true}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row columns={1}>
          <Grid.Column>
            {regionResults.map((rr, key) => (
              <div key={key}>
                {regionResults &&
                  regionResults.length > 1 && (
                    <Header
                      text={rr.title}
                      isRtl={isRtl}
                      isMobileView={isMobileView}
                      className={styles.customSubTitle}
                      lightBottomPadding={true}
                      subtitle={true}
                    />
                  )}
                {this.renderRegionHotels(rr.roomResult, key)}
              </div>
            ))}
          </Grid.Column>
        </Grid.Row>
      </div>
    );
  }
}

RegionsHotelsGroup.defaultProps = {
  onRegionHotelClick: () => {},
  isRtl: false,
  titles: {},
  isMobileView: false
};

RegionsHotelsGroup.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  regionResults: PropTypes.array,
  onRegionHotelClick: PropTypes.func,
  isMobileView: PropTypes.bool,
  selectedType: PropTypes.string,
  onShowHotelDetailsClick: PropTypes.func,
  propertyType: PropTypes.string,
  clubUserLoggedIn: PropTypes.bool,
  showPricePerNightThumb: PropTypes.bool
  //propertyTypePlural: PropTypes.string
};

export default RegionsHotelsGroup;



// WEBPACK FOOTER //
// ./src/components/RegionsHotelsGroup/RegionsHotelsGroup.js